import { ActionTypes } from "../actions/actionTypes";

const initialstate = {
  checkOtpSuccess: false,
  applicationId: "",
  userForCreateApp: null,
  phone: "",
  is_vip: false,
  app_exists: false,
  clients: null,
  clientId: 0,
  app_id: null,
  loading: false,
  sendFiles: false,
  error: null,
};
export const checkOtpReducer = (state = initialstate, action) => {
  switch (action.type) {
    case ActionTypes.CHECK_OTP_CODE_REQUEST: {
      return { ...state, error: null, loading: true };
    }
    case ActionTypes.CHECK_OTP_CODE_SUCCESS: {
      const { clients, app_id } = action.payload;
      return {
        ...state,
        loading: false,
        checkOtpSuccess: true,
        clients: clients !== null ? clients : [],
        app_id: app_id,
      };
    }
    case ActionTypes.CHEKC_OTP_CODE_ERROR: {
      return {
        ...state,
        error: action?.payload,
        app_id: action?.payload?.response?.data?.payload,
        loading: false,
      };
    }

    case ActionTypes.RESTART_DATA: {
      state = initialstate;
      return state;
    }
    case ActionTypes.RESET_ERROR: {
      return { ...state, error: null };
    }
    case ActionTypes.CREATE_APPLICATION_REQUEST:
      return { ...state, loading: true, error: null };
    case ActionTypes.CREATE_APPLICATION_SUCCESS:
      const {
        payload: { appId, clientId },
      } = action.payload;
      return {
        ...state,
        sendFiles: true,
        loading: false,
        app_id: appId,
        clientId,
      };
    case ActionTypes.CREATE_APPLICATION_FAILURE:
      return { ...state, loading: false, error: action.payload };
    case ActionTypes.SELECT_USER_FOR_CREATE_APP:
      return { ...state, userForCreateApp: action.payload };
    case ActionTypes.SET_API_KEY_FROM_KM:
      return {
        ...state,
        client_id: action.payload.client_id,
        app_id: action.payload.app_id,
      };
    case ActionTypes.CHECK_TOKEN_REQUEST:
      return { ...state, loading: true };
    case ActionTypes.CHECK_TOKEN_SUCCESS:
      return {
        ...state,
        loading: false,
        app_id: action.payload.appId,
        clientId: action.payload.clientId,
      };
    case ActionTypes.CHECK_TOKEN_FAILURE:
      return { ...state, loading: false, error: action.payload };

    default:
      return state;
  }
};
